export default "__VITE_ASSET__Cn$Y3mTu__"